import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

const convertNumberService = new ConvertNumService();

export default {
    name: "SchoolList",

    components: {
        MainLayout,
        StarRating,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            pg_status: false,
            filter: {
                school_name: "",
                order_by: ""
            },
            schools: {},
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["schoolId", "teacherId", "studentId", "userType"]),
    },

    methods: {
        onChange(page = 1) {
            this.filter.order_by = event.target.value
            axios.post("school/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.schools = response.data;                    
                    this.schools.total = convertNumberService.convertEng2Mm(this.schools.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.schools.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.schools.current_page);
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error)
                })
        },
        
        getSchools(page = 1) {
            axios.get("school/list?page=" + page)
                .then((response) => {
                    this.schools = response.data;
                    this.schools.total = convertNumberService.convertEng2Mm(this.schools.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.schools.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.schools.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
        
        schoolFilter(page = 1) {
            axios.post("school/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.schools = response.data;           
                    this.schools.total = convertNumberService.convertEng2Mm(this.schools.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.schools.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.schools.current_page);
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error)
                })
        },
    },
    
    mounted() {
        this.getSchools();
    }
};
